import React from 'react';
import { Step } from 'components/SteppedModal';
import useSocialShareModalFooter from 'containers/SocialShareModal/SocialShareModalFooter';
import { LinkedInSocialShareStep } from '../../types';
import LinkedInPostComposerStep from './LinkedInPostComposerStep';

export type UseLinkedInPostComposerStepConfig = {
  onShare: () => void;
};

export default function useLinkedInPostComposerStep({
  onShare,
}: UseLinkedInPostComposerStepConfig): Step<LinkedInSocialShareStep> {
  const footerConfig = useSocialShareModalFooter({
    onShare,
  });

  return {
    ...footerConfig,
    id: 'composer',
    component: <LinkedInPostComposerStep />,
  };
}
